import { useSetRecoilState, useRecoilValue } from "recoil";

import { useAnalyticsContext } from "MVVM/Hooks/useAnalyticsContext";
import {
  ShowWatchLimitBlockerState,
  BlockedPlayerNameState,
  BlockedClipState,
  PlaylistIdState,
} from "MVVM/State/embeddablePlaylist";
import { PlaylistClip } from "MVVM/Views/EmbeddablePlaylist/@types";

export function useWatchLimit() {
  const setBlockedPlayerName = useSetRecoilState(BlockedPlayerNameState);
  const setBlockedClip = useSetRecoilState(BlockedClipState);
  const setShowWatchLimitBlocker = useSetRecoilState(
    ShowWatchLimitBlockerState,
  );
  const playlistId = useRecoilValue(PlaylistIdState);

  const { track } = useAnalyticsContext();

  const handleWatchLimitReached = (
    playerName: string,
    clickedClip: PlaylistClip,
  ) => {
    const platform =
      new URLSearchParams(window.location.search).get("platform") || "unknown";

    track("Watch Limit - Blocked", {
      location: "embeddable_playlist",
      locationIdentifier: "watch_limit_reached",
      source: "website",
      platform,
      clipId: clickedClip?.shareId,
      playlistId: playlistId,
      playerName: playerName,
    });

    setBlockedPlayerName(playerName);
    setBlockedClip(clickedClip);
    setShowWatchLimitBlocker(true);
  };

  const handleCloseBlocker = () => setShowWatchLimitBlocker(false);

  return { handleWatchLimitReached, handleCloseBlocker };
}
